import { PAGE_SIZE } from '@/config/GlobalText'
import { mapGetters, mapActions } from 'vuex'
import { getBrowserInfo } from '@/utils'
import saveAs from '@/utils/fileSave'
import config from '@/config/ApiConfig'
// require('../utils/blob.js')
// console.error(Uint8Array)
export default {
    data: function () {
        return {
            PAGE_SIZE,
            //分页参数
            pagination: {
                current: 1,
                pageSize: PAGE_SIZE,
                total: 0
            },
            dataSource: [],
            queryVal: {}
        }
    },
    computed: {
        ...mapGetters(['getRecruitList', 'getPostList'])
    },
    methods: {
        ...mapActions(['loadRecruitList', 'loadPostList']),
        loadData(params = {}) {
            this.queryVal = params
            const pageNo = this.pagination.current
            this.list && this.list({ ...this.queryVal, pageNo })
        },
        handlePageChange(currentPage) {
            this.pagination.current = currentPage
            this.loadData(this.queryVal, currentPage)
        },
        openModel(modelName) {
            this.$refs[modelName] && this.$refs[modelName].open()
        },
        closeModel(modelName) {
            this.$refs[modelName] && this.$refs[modelName].close()
        },
        // 加载招考信息列表
        async loadListForQuery() {
            const options =
                this.getRecruitList.length !== 0
                    ? this.getRecruitList
                    : await this.loadRecruitList({ isRelease: 1 })

            var item = this.queryParams[0];
            item.options = options;
            item.defaultValue = options[0] && options[0].value;
            this.$set(this.queryParams, 0, item);
        },
        // 加载岗位列表
        async loadPostListForQuery(data = {}, key, query) {
            const options = await this.loadPostList(data)
            const target = this.queryParams.filter((item, index) => {
                return item.code === key
            })
            if (query) {
                query[key] = ''
            }
            if (options.length > 0) {
                this.$nextTick(() => {
                    target[0].options.splice(1, target[0].options.length, ...options)
                })
            }
        },
        dataURItoBlob(base64Data) {
            const { type = 'Chrome', version } = getBrowserInfo()
            console.info(type, version)
            var byteString;
            if (base64Data.split(",")[0].indexOf("base64") >= 0)
                byteString = atob(base64Data.split(",")[1]);
            //base64 解码
            else {
                if (type === 'IE' && version >= 10) {
                    byteString = atob(base64Data);
                } else if (type === 'IE' && version < 10) {
                    // IE10以下内核不支持atob
                    byteString = Base64.atob(base64Data);
                    // byteString =  atob(base64Data);
                } else {
                    byteString = atob(base64Data);
                }
            }
            var ia = new Uint8Array(byteString.length); //创建视图
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            var blob = new Blob([ia], {
                type: 'application/vnd.ms-excel;application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            return blob;
        },
        isIE() {
            return navigator.userAgent.toLowerCase().indexOf('trident') > -1 ? true : false;
        },
        dataURLtoFile(dataurl, filename) {
            var byteString;
            if (!this.isIE()) {
                byteString = atob(dataurl);
            } else {
                // IE10以下内核不支持atob
                byteString = Base64.decode(dataurl);
            }

            var n = byteString.length, u8arr = new Uint8Array(n);

            while (n--) {

                u8arr[n] = byteString.charCodeAt(n);

            }

            return new File([u8arr], filename, { type: 'application/vnd.ms-excel' });

        },
        downloadFiles(url, filename) {
            
            const fileUrl = url.replace(/\\/g, "/");
            if (getBrowserInfo().type == 'IE' && getBrowserInfo().version < 10) {
                // var aLink = document.createElement('a');
                // aLink.href = `${config.apiServer}/${fileUrl}`;
                // aLink.download = fileUrl || ''; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效

                //     event = document.createEvent('MouseEvents');
                //     event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                // aLink.dispatchEvent(event);
                window.open(`${config.apiServer}/${fileUrl}`)
                // window.close()
                return false;
            }
            const file = `${config.apiServer}/${fileUrl}`
            download(file)
        },
        exportByBlobFile(data, filename) {
            console.info(data, filename)
            var blob = new Blob([data], {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            saveAs(blob, filename + '.xlsx')
        },
        // 导出文件方法
        exportFile(base64, filename) {
            // base64转换成blob
            const data = this.dataURItoBlob(base64)
            // var blob = new Blob([data], {
            //     type:
            //         "application/vnd.ms-excel;application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            // }); 
            // console.error(data,'流文件')
            return saveAs(data, filename + '.xlsx')
        }
    }
}
